import axios, { type AxiosInstance } from "axios";
import type { Router } from "vue-router";
import { Store } from "vuex";
import { setupResponseInterceptor } from "./setup-response-interceptor";
import { setupRequestInterceptor } from "./setup-request-interceptor";

export interface IHttpService extends AxiosInstance {
  store?: Store<any>;
  router?: Router;
}

export let HttpService: IHttpService = axios.create();

export const initHttpService = (store?: any, router?: Router) => {
  HttpService = axios.create({});

  HttpService.store = store;
  HttpService.router = router;

  setupRequestInterceptor(HttpService);

  setupResponseInterceptor(HttpService);
};
